import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  Search,
  User,
  BookOpen,
  Users,
  Calendar,
  MoreVertical,
  Eye,
  Edit,
  Trash2,
  X,
  Phone,
  GraduationCap,
  Mail,
  MapPin,
} from 'lucide-react';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import useFetch from '../constants/useFetch';
import { API_BASE_URL } from '../constants';
import SkeletonTable from '../components/SkeletonTable';

// ==================== ACTION MODAL ====================
const ActionModal = ({ action, selectedTeachers, teacherIds, onSubmit, onClose, subjectOptions, classOptions }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  // console.log({formData});
  
  const booleanOptions = [
    { value: 'yes', label: 'Assign' },
    { value: 'no', label: 'Remove' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSubmit(formData);
    } finally {
      setLoading(false);
    }
  };

  const renderForm = () => {
    switch (action) {
      // case 'assign-subject-head-teacher': {
      //   // Find the actual teacher object from teachers list using teacherIds
      //   const teacher = selectedTeachers.find(t => teacherIds.includes(t.teacher_id));

      //   const taughtSubjects = teacher?.subject_classes
      //     ?.map(s => s.subject_name)
      //     .sort() || [];

      //   const subjectOptionsForHead = taughtSubjects.map(name => ({
      //     value: name,
      //     label: name,
      //   }));

      //   const currentHeadSubject = teacher?.subject_head_teacher_for || null;

      //   return (
      //     <div className="space-y-4">
      //       <div>
      //         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      //           Select Subject to Assign as Head Teacher
      //         </label>
      //         <Select
      //           options={[
      //             { value: '', label: 'Remove Head Teacher Role' },
      //             ...subjectOptionsForHead,
      //           ]}
      //           value={
      //             subjectOptionsForHead.find(o => o.value === currentHeadSubject) ||
      //             { value: '', label: 'Remove Head Teacher Role' }
      //           }
      //           onChange={(opt) => setFormData({ ...formData, headTeacherSubject: opt })}
      //           placeholder="Choose subject..."
      //           isSearchable
      //         />
      //       </div>

      //       {taughtSubjects.length === 0 && (
      //         <p className="text-sm text-amber-600 dark:text-amber-400">
      //           This teacher has no subjects assigned yet.
      //         </p>
      //       )}
      //     </div>
      //   );
      // }
      ////////////////////////////////////////
      // case 'assign-subject-head-teacher': {
      //   const teacher = selectedTeachers.find(t => teacherIds.includes(t.teacher_id));

      //   const taughtSubjects = teacher?.subject_classes
      //     ?.map(s => s.subject_name)
      //     .sort() || [];

      //   const subjectOptionsForHead = taughtSubjects.map(name => ({
      //     value: name,
      //     label: name,
      //   }));

      //   const currentHeadSubject = teacher?.subject_head_teacher_for || null;

      //   return (
      //     <div className="space-y-4">
      //       <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      //         Assign as Head Teacher for:
      //       </label>

      //       <Select
      //         options={subjectOptionsForHead}
      //         // value={subjectOptionsForHead.find(o => o.value === currentHeadSubject) || null}
      //         value={formData}
      //         onChange={(opt) => 
      //           setFormData({ ...formData, headTeacherSubject: opt }) // opt can be null → removes role
      //         }
      //         placeholder={
      //           taughtSubjects.length === 0
      //             ? "No subjects assigned"
      //             : currentHeadSubject
      //               ? `Currently Head: ${currentHeadSubject}`
      //               : "Choose a subject..."
      //         }
      //         isSearchable
      //         isClearable={!!currentHeadSubject} // allows clearing selection to remove role
      //         className="text-gray-900 dark:text-white"
      //       />

      //       {taughtSubjects.length === 0 && (
      //         <p className="text-sm text-amber-600 dark:text-amber-400 mt-2">
      //           This teacher has no subjects assigned yet.
      //         </p>
      //       )}

      //       {currentHeadSubject && taughtSubjects.length > 0 && (
      //         <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
      //           Clear the selection to remove Head Teacher role.
      //         </p>
      //       )}
      //     </div>
      //   );
      // }
      case 'assign-subject-head-teacher': {
        const teacher = selectedTeachers.find(t => teacherIds.includes(t.teacher_id));

        const taughtSubjects = teacher?.subject_classes
          ?.map(s => s.subject_name)
          .sort() || [];

        const subjectOptionsForHead = taughtSubjects.map(name => ({
          value: name,
          label: name,
        }));

        const currentHeadSubject = teacher?.subject_head_teacher_for || null;

        // This is the key: we store the full option object in formData.headTeacherSubject
        const selectedOption = formData.headTeacherSubject || 
          (currentHeadSubject 
            ? subjectOptionsForHead.find(o => o.value === currentHeadSubject)
            : null
          );

        return (
          <div className="space-y-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Assign as Head Teacher for:
            </label>

            <Select
              options={subjectOptionsForHead}
              value={selectedOption}  // ← This shows the correct selected value
              onChange={(opt) => 
                setFormData({ ...formData, headTeacherSubject: opt }) // opt is null or {value, label}
              }
              placeholder={
                taughtSubjects.length === 0
                  ? "No subjects assigned"
                  : currentHeadSubject
                    ? `Currently Head: ${currentHeadSubject}`
                    : "Select a subject..."
              }
              isSearchable
              isClearable={!!currentHeadSubject}
              className="text-gray-900 dark:text-white"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 42,
                }),
              }}
            />

            {taughtSubjects.length === 0 && (
              <p className="text-sm text-amber-600 dark:text-amber-400 mt-2">
                This teacher has no subjects assigned yet.
              </p>
            )}

            {currentHeadSubject && taughtSubjects.length > 0 && !selectedOption && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                Clear selection to remove Head Teacher role.
              </p>
            )}
          </div>
        );
      }

      case 'assign-class-form-teacher':
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Class(es)</label>
              <Select
                isMulti={teacherIds.length === 1}
                options={classOptions}
                value={formData.classes}
                onChange={(opts) => setFormData({ ...formData, classes: opts || [] })}
                placeholder="Select classes..."
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Form Teacher?</label>
              <Select
                options={booleanOptions}
                value={formData.formTeacher}
                onChange={(opt) => setFormData({ ...formData, formTeacher: opt })}
              />
            </div>
          </div>
        );

       case 'assign-class-form-teacher':

      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">
          {action.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} ({teacherIds.length} teacher{teacherIds.length > 1 ? 's' : ''})
        </h3>
        <form onSubmit={handleSubmit}>
          {renderForm()}
          <div className="flex gap-3 mt-6">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border rounded hover:bg-gray-100 dark:hover:bg-gray-700">
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? 'Saving...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ==================== MAIN COMPONENT ====================
const Teachers = () => {
  const { data: dashboardData, loading } = useFetch(`${API_BASE_URL}/api/web/admin/all-teachers`, 'teachersData');
  const [teachers, setTeachers] = useState([]);
  const userInfo = useSelector(state => state?.auth?.user);

  const currentSession = userInfo?.currentSession || dashboardData?.currentSession || 'N/A';
  const currentTerm = userInfo?.currentTerm || dashboardData?.currentTerm || 'N/A';

  const classrooms = dashboardData?.classrooms || [];
  const subjects = dashboardData?.subjects || [];

  // Load teachers
  useEffect(() => {
    if (dashboardData?.allTeachers) {
      setTeachers(dashboardData.allTeachers);
    }
  }, [dashboardData?.allTeachers]);

  // State
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('a-z');
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
  const [actionDropdownId, setActionDropdownId] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [modalTeacherIds, setModalTeacherIds] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedTeacherForAssign, setSelectedTeacherForAssign] = useState(null);

  // Options
  const classOptions = classrooms.map(c => ({ value: c.id, label: c.class_name }));
  const bulkActions = [
    { value: 'assign-subjects-classes', label: 'Assign Subjects & Classes (Advanced)', icon: BookOpen, advanced: true },
    { value: 'assign-subject-head-teacher', label: 'Assign/Remove Subject Head Teacher', icon: GraduationCap },
    { value: 'assign-class-form-teacher', label: 'Assign/Remove Class Form Teacher', icon: User },
  ];

  // Filtered & sorted teachers
  // useMemo
  // const filteredTeachers = useMemo(() => {
  //   return teachers.filter(teacher => {
  //     const q = searchQuery.toLowerCase();
  //     return (
  //       teacher.firstname?.toLowerCase().includes(q) ||
  //       teacher.lastname?.toLowerCase().includes(q) ||
  //       teacher.email?.toLowerCase().includes(q) ||
  //       teacher.phone?.includes(q)
  //     );
  //   });
  // }, [teachers, searchQuery]);

    const filteredTeachers = useMemo(() => {
      const q = searchQuery.toLowerCase().trim();
      if (!q) return teachers;

      return teachers.filter(teacher => {
        // 1. Basic name/email/phone search
        const basic = `${teacher.firstname} ${teacher.lastname} ${teacher.email} ${teacher.phone}`.toLowerCase();
        if (basic.includes(q)) return true;

        // 2. Extract subjects as string
        const subjectsStr = (teacher.subject_classes || [])
          .map(s => s.subject_name?.toLowerCase() || '')
          .join(' ');

        // 3. Is form teacher?
        const isFormTeacher = !!teacher.form_teacher_class;

        // 4. Detect "form teacher" intent
        const wantsFormTeacher = /\bform\s*teacher\b|\bteacher\s*form\b/i.test(q);

        // 5. Remove "form teacher" from query to get possible subject
        let subjectQuery = q.replace(/\bform\s*teacher\b|\bteacher\s*form\b/gi, '').trim();

        // If only "form teacher" → show all form teachers
        if (wantsFormTeacher) {
          if (!subjectQuery) return isFormTeacher;
          // Else: form teacher + subject
          return isFormTeacher && subjectsStr.includes(subjectQuery);
        }

        // 6. Regular subject search
        return subjectsStr.includes(q);
      });
    }, [teachers, searchQuery]);

  // Sort teachers
  const sortedTeachers = useMemo(() => {
    const list = [...filteredTeachers];
    if (sortOption === 'a-z') {
      list.sort((a, b) => `${a.lastname} ${a.firstname}`.localeCompare(`${b.lastname} ${b.firstname}`));
    } else {
      list.sort((a, b) => `${b.lastname} ${b.firstname}`.localeCompare(`${a.lastname} ${a.firstname}`));
    }
    return list;
  }, [filteredTeachers, sortOption]);

  const paginated = sortedTeachers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(sortedTeachers.length / itemsPerPage);

  // Checkbox logic
  const allOnPageSelected = paginated.length > 0 && paginated.every(t => selectedTeacherIds.includes(t.teacher_id));
  const toggleSelectAll = () => {
    if (allOnPageSelected) {
      setSelectedTeacherIds(prev => prev.filter(id => !paginated.some(t => t.teacher_id === id)));
    } else {
      setSelectedTeacherIds(prev => [
        ...prev.filter(id => !paginated.some(t => t.teacher_id === id)),
        ...paginated.map(t => t.teacher_id),
      ]);
    }
  };

  const toggleTeacher = (id) => {
    setSelectedTeacherIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Open modal with correct teacher objects
  const openActionModal = (action, ids = selectedTeacherIds) => {
    if (action === 'assign-subjects-classes') {
      if (ids.length !== 1) {
        alert("Please select exactly one teacher for advanced assignment");
        return;
      }
      setSelectedTeacherForAssign(teachers.find(t => t.teacher_id === ids[0]));
      setShowAssignModal(true);
      setActionDropdownId(null);
      return;
    }
    
    if (action === 'assign-subjects-classes' && ids.length > 1) {
      alert("Please select exactly one teacher for advanced assignment");
      return;
    }
    
    setSelectedAction(action);
    setModalTeacherIds(ids);
    setShowActionModal(true);
  };

  // ──────────────────────────────────────────────────────────────
    // NEW MODAL COMPONENT — PUT THIS ANYWHERE INSIDE Teachers()
    // ──────────────────────────────────────────────────────────────
    const AssignSubjectsClassesModal = ({ teacher, onClose }) => {
      const [rows, setRows] = useState([]);
      const [loading, setLoading] = useState(true);
  
      const subjectOptions = useMemo(() => 
        (dashboardData?.subjects || []).map(s => ({
          value: s.id,
          label: s.subject_name
        })), [dashboardData?.subjects]
      );
  
      const classOptions = useMemo(() => 
        (dashboardData?.classrooms || []).map(c => ({
          value: c.id,
          label: c.class_name
        })), [dashboardData?.classrooms]
      );
  
      // Load existing assignments
      useEffect(() => {
        const load = async () => {
          try {
            const res = await fetch(`${API_BASE_URL}/api/web/admin/teacher-assignments/${teacher.teacher_id}`, {
              headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
            });
            const json = await res.json();
            if (json.success && json.assignments.length > 0) {
              const formatted = json.assignments.map(a => ({
                subject: subjectOptions.find(o => o.value === a.subject_id),
                classes: classOptions.filter(o => a.classroom_ids.includes(o.value))
              }));
              setRows(formatted);
            } else {
              // Start with one empty row
              setRows([{ subject: null, classes: [] }]);
            }
          } catch (err) {
            setRows([{ subject: null, classes: [] }]);
          } finally {
            setLoading(false);
          }
        };
        load();
      }, [teacher.teacher_id]);
  
      const addRow = () => setRows([...rows, { subject: null, classes: [] }]);
  
      const updateRow = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
      };
  
      const removeRow = (index) => {
        if (rows.length === 1) return; // keep at least one row
        setRows(rows.filter((_, i) => i !== index));
      };
  
      const handleSave1 = async () => {
        const validRows = rows.filter(r => r.subject && r.classes.length > 0);
        if (validRows.length === 0) {
          alert("Please assign at least one subject with classes");
          return;
        }
  
        const payload = {
          teacher_id: teacher.teacher_id,
          assignments: validRows.map(r => ({
            subject_id: r.subject.value,
            classroom_ids: r.classes.map(c => c.value)
          }))
        };
  
        try {
          const res = await fetch(`${API_BASE_URL}/api/web/admin/assign-teacher-subjects-classes`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(payload)
          });
  
          const json = await res.json();
          if (json.success) {
            // Update the teachers list instantly
            setTeachers(prev => prev.map(t =>
              t.teacher_id === teacher.teacher_id
                ? { ...t, subjects_taught: json.teacher.subjects_taught, classes: json.teacher.classes }
                : t
            ));
            onClose();
            alert("Assignments saved successfully!");
          } else {
            alert(json.message || "Failed to save");
          }
        } catch (err) {
          alert("Network error");
        }
      };
  
      const handleSave = async () => {
        const validRows = rows.filter(r => r.subject && r.classes.length > 0);
        if (validRows.length === 0) {
          alert("Please assign at least one subject with classes");
          return;
        }
  
        const payload = {
          teacherIds: [teacher.teacher_id],
          action: "assign-subjects-classes",
          assignments: validRows.map(r => ({
            subject_id: r.subject.value,
            classroom_ids: r.classes.map(c => c.value)
          }))
        };
  
        try {
          const res = await fetch(`${API_BASE_URL}/api/web/admin/assign-teachers`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(payload)
          });
  
          const json = await res.json();
          if (json.success && json.updatedTeachers?.[0]) {
            const updated = json.updatedTeachers[0];
            setTeachers(prev => prev.map(t =>
              t.teacher_id === teacher.teacher_id
                ? { ...t, teaching_summary: updated.teaching_summary }
                : t
            ));
            onClose();
            alert("Assignments saved successfully!");
          } else {
            alert(json.message || "Failed");
          }
        } catch (err) {
          alert("Network error");
        }
      };
  
      if (loading) {
        return (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-xl p-8">Loading assignments...</div>
          </div>
        );
      }
  
      return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-5xl my-8">
            <div className="p-6 border-b dark:border-gray-700 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold">
                  Assign Subjects & Classes
                </h2>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  {teacher.firstname} {teacher.lastname} • {dashboardData?.currentSession} • {dashboardData?.currentTerm} Term
                </p>
              </div>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                <X className="w-6 h-6" />
              </button>
            </div>
  
            <div className="p-6 space-y-5 max-h-96 overflow-y-auto">
              {rows.map((row, i) => (
                <div key={i} className="flex gap-4 items-end">
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1">Subject</label>
                    <Select
                      options={subjectOptions}
                      value={row.subject}
                      onChange={(opt) => updateRow(i, 'subject', opt)}
                      placeholder="Choose subject..."
                      isSearchable
                      className="react-select"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium mb-1">Classes</label>
                    <Select
                      isMulti
                      options={classOptions}
                      value={row.classes}
                      onChange={(opts) => updateRow(i, 'classes', opts || [])}
                      placeholder="Choose classes..."
                      className="react-select"
                    />
                  </div>
                  <button
                    onClick={() => removeRow(i)}
                    className="mb-1 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
                    disabled={rows.length === 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
  
              <button
                onClick={addRow}
                className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
              >
                + Add Another Subject
              </button>
            </div>
  
            <div className="p-6 border-t dark:border-gray-700 flex justify-end gap-3">
              <button
                onClick={onClose}
                className="px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-lg"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-8 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Save All Assignments
              </button>
            </div>
          </div>
        </div>
      );
    };
    // ──────────────────────────────────────────────────────────────
    // END OF MODAL
    // ──────────────────────────────────────────────────────────────

  // Submit handler
  const handleActionSubmit = async (formData) => {
    const payload = {
      teacherIds: modalTeacherIds,
      action: selectedAction,
      headTeacherSubject: formData.headTeacherSubject?.value || null,
      classes: formData.classes ? formData.classes.map(c => c.value) : undefined,
      formTeacher: formData.formTeacher?.value,
    };

    const res = await fetch(`${API_BASE_URL}/api/web/admin/assign-teachers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
      body: JSON.stringify(payload),
    });

    const json = await res.json();
    if (json.success) {
      setTeachers(prev => {
        const updated = json.updatedTeachers || [];
        return prev.map(t => {
          const upd = updated.find(u => u.teacher_id === t.teacher_id);
          return upd ? { ...t, ...upd } : t;
        });
      });
      setSelectedTeacherIds([]);
      setShowActionModal(false);
      alert('Success!');
    } else {
      alert(json.message || 'Failed');
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      {selectedTeacherIds.length === 0 && (
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl p-6 text-white">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold">Teachers</h1>
              <div className="flex flex-wrap gap-4 mt-2 text-blue-100">
                <span className="flex items-center gap-2"><Users className="w-5 h-5" /> {teachers.length} Teachers</span>
                <span className="flex items-center gap-2"><Calendar className="w-5 h-5" /> {currentSession}</span>
                <span className="flex items-center gap-2"><GraduationCap className="w-5 h-5" /> {currentTerm} Term</span>
              </div>
            </div>
            <Link to="/add-teacher" className="bg-white/20 hover:bg-white/30 px-6 py-3 rounded-lg flex items-center gap-2">
              <User className="w-5 h-5" /> Add Teacher
            </Link>
          </div>
        </div>
      )}

      {/* Bulk Actions */}
      {selectedTeacherIds.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow border p-4">
          <p className="font-medium mb-3">{selectedTeacherIds.length} selected</p>
          <div className="flex flex-wrap gap-3">
            {bulkActions.map(act => (
              <button
                key={act.value}
                onClick={() => openActionModal(act.value)}
                className="flex items-center gap-2 px-4 py-2 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg hover:bg-blue-200 dark:hover:bg-blue-900/50"
              >
                <act.icon className="w-4 h-4" />
                {act.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Table */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow overflow-hidden">
        <div className="p-6 border-b dark:border-gray-700 flex flex-col gap-4 lg:flex-row lg:justify-between">
          <h2 className="text-xl font-semibold">All Teachers</h2>
          <div className="flex flex-wrap gap-3">
            <div className="relative">
              <Search className="absolute left-3 top-1/3 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="pl-10 pr-4 py-2 border rounded-lg dark:bg-gray-700"
              />
              
              <div className="text-xs text-gray-500 mt-1">
                Tip: Type <code className="bg-gray-200 px-1 rounded">form teacher</code> to see form teachers • 
                Type <code className="bg-gray-200 px-1 rounded">mathematics</code> to filter by subject
              </div>

            </div>
            
            <select
              value={itemsPerPage}
              onChange={e => setItemsPerPage(Number(e.target.value))}
              className="px-3 py-2 border rounded-lg dark:bg-gray-700"
            >
              {[10, 20, 30, 50].map(n => (
                <option key={n} value={n}>{n} per page</option>
              ))}
            </select>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-6 py-3 text-left">
                  <input
                    type="checkbox"
                    checked={allOnPageSelected}
                    onChange={toggleSelectAll}
                    className="rounded"
                  />
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Teacher</th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Contact</th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Subjects & Classes</th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y dark:divide-gray-700">
              {loading ? (
                <>
                  <SkeletonTable rows={5} columns={7} />
                </>
              ) : paginated.map(teacher => (
                <tr key={teacher.teacher_id} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                  <td className="px-6 py-4">
                    <input
                      type="checkbox"
                      checked={selectedTeacherIds.includes(teacher.teacher_id)}
                      onChange={() => toggleTeacher(teacher.teacher_id)}
                    />
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      {teacher.profile_picture ? (
                        <img
                          src={teacher.profile_picture}
                          alt=""
                          className="w-10 h-10 rounded-full object-cover cursor-pointer"
                          onClick={() => setSelectedImage(teacher.profile_picture)}
                        />
                      ) : (
                        <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold">
                          {teacher.firstname?.[0]}{teacher.lastname?.[0]}
                        </div>
                      )}
                      <div>
                        <div className="font-medium">
                          {/* {teacher.title} {teacher.lastname} {teacher.firstname} */}
                          {teacher.lastname} {teacher.firstname}
                        </div>
                        <div className="text-sm text-gray-500">{teacher.email}</div>
                        {teacher.form_teacher_class && (
                          <div className="text-xs text-blue-600">Form Teacher: {teacher.form_teacher_class}</div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex items-center gap-1">
                      <Phone className="w-4 h-4" />
                      {teacher.phone || '—'}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {teacher.subject_classes?.length > 0 ? (
                      <div className="space-y-1">
                        {teacher.subject_classes.map((sub, i) => (
                          <div key={i} className="flex flex-wrap items-center gap-2">
                            <span className="font-medium text-blue-700 dark:text-blue-400">
                              {sub.subject_name}
                            </span>
                            {sub.classes.length > 0 ? (
                              <div className="flex flex-wrap gap-1">
                                {sub.classes.map(cls => (
                                  <span key={cls} className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 rounded-full">
                                    {cls}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <span className="text-xs text-gray-500 italic">No class</span>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span className="text-gray-400 italic">No subjects</span>
                    )}

                    {/* Head Teacher Badge */}
                    {teacher.subject_head_teacher_for && (
                      <div className="mt-2">
                        <span className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 rounded-full">
                          <GraduationCap className="w-3.5 h-3.5" />
                          Head: {teacher.subject_head_teacher_for}
                        </span>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      teacher.status === 'active'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                        : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                    }`}>
                      {teacher.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 relative">
                    <button
                      onClick={() => setActionDropdownId(actionDropdownId === teacher.teacher_id ? null : teacher.teacher_id)}
                      className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
                    >
                      <MoreVertical className="w-5 h-5" />
                    </button>
                    {actionDropdownId === teacher.teacher_id && (
                      <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border dark:border-gray-700 z-10">
                        <button onClick={() => { setSelectedTeacher(teacher); setShowDetailsModal(true); setActionDropdownId(null); }}
                          className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm"
                        >
                          <Eye className="w-4 h-4" /> View Details
                        </button>
                        <Link
                          to={`/edit-teacher/${teacher.uuid}`}
                          className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm text-blue-600"
                        >
                          <Edit className="w-4 h-4" /> Edit
                        </Link>
                        {bulkActions.map(act => (
                          <button
                            key={act.value}
                            onClick={() => {
                              openActionModal(act.value, [teacher.teacher_id]);
                              setActionDropdownId(null);
                            }}
                            className="w-full text-left flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm"
                          >
                            <act.icon className="w-4 h-4" />
                            {act.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-between items-center px-6 py-4 border-t dark:border-gray-700">
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, sortedTeachers.length)} of {sortedTeachers.length}
            </span>
            <div className="flex gap-2">
              <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="px-3 py-1 border rounded disabled:opacity-50">Prev</button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-600 text-white' : ''}`}
                >
                  {i + 1}
                </button>
              ))}
              <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="px-3 py-1 border rounded disabled:opacity-50">Next</button>
            </div>
          </div>
        )}
      </div>

      {/* Modals */}
      {/* Teacher Details Modal */}
      {showDetailsModal && selectedTeacher && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Teacher Details
              </h2>
              <button
                  onClick={() => setShowDetailsModal(false)}
                  className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                  <X className="w-6 h-6" />
              </button>
              </div>
              <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  <div className="lg:col-span-1">
                  <div className="text-center">
                      <div className="relative inline-block">
                      {selectedTeacher?.profile_picture ? (
                          <img
                          src={selectedTeacher.profile_picture}
                          alt={`${selectedTeacher?.firstname} ${selectedTeacher?.lastname}`}
                          className="w-32 h-32 rounded-full object-cover mx-auto border-4 border-blue-100 dark:border-blue-900"
                          />
                      ) : (
                          <div className="w-32 h-32 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto border-4 border-blue-100 dark:border-blue-900">
                              <User className="w-16 h-16 text-white" />
                          </div>
                      )}
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-4">
                      {selectedTeacher?.firstname} {selectedTeacher?.middlename} {selectedTeacher?.lastname}
                      </h3>
                      <p className="text-gray-600 dark:text-gray-400">{selectedTeacher?.subject}</p>
                      <div className="mt-4">
                      <span className={`inline-flex px-3 py-1 text-sm font-semibold rounded-full ${
                          selectedTeacher.status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                          'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                      }`}>
                          {selectedTeacher.status}
                      </span>
                      </div>
                  </div>
                  </div>
                  <div className="lg:col-span-2 space-y-6">
                  <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <User className="w-5 h-5 mr-2" />
                      Personal Information
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Full Name</label>
                              <p className="text-gray-900 dark:text-white">{selectedTeacher?.firstname} {selectedTeacher?.middlename} {selectedTeacher?.lastname}</p>
                          </div>
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Gender</label>
                              <p className="text-gray-900 dark:text-white">{selectedTeacher.gender || 'N/A'}</p>
                          </div>
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Date of Birth</label>
                              <p className="text-gray-900 dark:text-white">{formatDate(selectedTeacher?.employment_date)}</p>
                          </div>
                      </div>
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <BookOpen className="w-5 h-5 mr-2" />
                      Academic Information
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Qualification</label>
                              <p className="text-gray-900 dark:text-white">{selectedTeacher.qualification || 'N/A'}</p>
                          </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Experience</label>
                              <p className="text-gray-900 dark:text-white">{selectedTeacher.experience || 'N/A'}</p>
                          </div>
                      </div>
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <Mail className="w-5 h-5 mr-2" />
                      Contact Information
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Email</label>
                              <p className="text-gray-900 dark:text-white flex items-center">
                              <Mail className="w-4 h-4 mr-1" />
                              {selectedTeacher.email || 'N/A'}
                              </p>
                          </div>
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Phone</label>
                              <p className="text-gray-900 dark:text-white flex items-center">
                              <Phone className="w-4 h-4 mr-1" />
                              {selectedTeacher.phone || 'N/A'}
                              </p>
                          </div>
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Alternative Phone</label>
                              <p className="text-gray-900 dark:text-white">{selectedTeacher.alternative_phone || 'N/A'}</p>
                          </div>
                          <div>
                              <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Emergency Phone</label>
                              <p className="text-gray-900 dark:text-white flex items-center">
                              <Phone className="w-4 h-4 mr-1" />
                              {selectedTeacher?.emergency_phone || 'N/A'}
                              </p>
                          </div>
                      </div>
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <MapPin className="w-5 h-5 mr-2" />
                      Address & Additional Information
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                          <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Address</label>
                          <p className="text-gray-900 dark:text-white">{selectedTeacher.address || 'N/A'}</p>
                      </div>
                      <div>
                          <label className="text-sm font-medium text-gray-600 dark:text-gray-400">State of Origin</label>
                          <p className="text-gray-900 dark:text-white">{selectedTeacher.state_of_origin || 'N/A'}</p>
                      </div>
                      <div>
                          <label className="text-sm font-medium text-gray-600 dark:text-gray-400">LGA</label>
                          <p className="text-gray-900 dark:text-white">{selectedTeacher.lga || 'N/A'}</p>
                      </div>
                      <div>
                          <label className="text-sm font-medium text-gray-600 dark:text-gray-400">Nationality</label>
                          <p className="text-gray-900 dark:text-white">{selectedTeacher.nationality || 'N/A'}</p>
                      </div>
                      
                      </div>
                  </div>
                  </div>
              </div>
              </div>
              <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 dark:border-gray-700">
                  <button
                      onClick={() => setShowDetailsModal(false)}
                      className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
                  >
                      Close
                  </button>
              
              </div>
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Preview" className="max-w-full max-h-full rounded-lg" />
        </div>
      )}

      {showActionModal && (
        <ActionModal
          action={selectedAction}
          selectedTeachers={teachers}
          teacherIds={modalTeacherIds}
          onSubmit={handleActionSubmit}
          onClose={() => setShowActionModal(false)}
          classOptions={classOptions}
        />
      )}
      {/* NEW MODAL */}
      {showAssignModal && selectedTeacherForAssign && (
        <AssignSubjectsClassesModal
          teacher={selectedTeacherForAssign}
          onClose={() => {
            setShowAssignModal(false);
            setSelectedTeacherForAssign(null);
          }}
        />
      )}
    </div>
  );
};

export default Teachers;